export default __webpack_public_path__ + "static/media/signup-background-item.01126e05.svg";